import { render } from "./bodyTabMenu.vue?vue&type=template&id=91980a0c"
import script from "./bodyTabMenu.vue?vue&type=script&lang=js"
export * from "./bodyTabMenu.vue?vue&type=script&lang=js"

import "./bodyTabMenu.vue?vue&type=style&index=0&id=91980a0c&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__